import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { menuHeaderStyles } from '../../../../services/db/navigationStyle';
import AppSelectedIcon from '../../../AppSelectedIcon';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setMenuHeader } from 'redux/actions';
import { useAuthUser } from '@crema/utility/AuthHooks';

const HeaderMenuStyle = () => {
    const { typeMenuHeader } = useSelector(state => state.common)
    const dispatch = useDispatch()
    const { user } = useAuthUser()
    const isRoleMenu = user.roles_coofis.some(item => item.state === 'CUSTOM_MENU')

    const onHeaderMenuStyleChange = (type) => {
        const temp = localStorage.getItem('menu')
        const menu = JSON.parse(temp)

        const tempMenu = {
            ...menu,
            type: type
        }
        localStorage.setItem('menu', JSON.stringify(tempMenu))
        dispatch(setMenuHeader(type))
    }

    return (
        isRoleMenu &&
        <>
            <Box component='h4' sx={{ mb: 3 }}>
                Header Menu Style
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: '-10px',
                    marginRight: '-10px',
                }}
            >
                {menuHeaderStyles.map((item) => {
                    return (
                        <Box
                            sx={{
                                paddingLeft: 2.5,
                                paddingRight: 2.5,
                                marginBottom: 5,
                                flex: 1
                            }}
                            key={item.id}
                        >
                            <Box
                                sx={{
                                    position: 'relative',
                                    cursor: 'pointer',
                                }}
                                onClick={() => onHeaderMenuStyleChange(item.alias)}
                            >
                                <img src={item.image} alt='nav' />
                                {typeMenuHeader === item.alias ? <AppSelectedIcon /> : null}
                                <Typography textTransform={'capitalize'}>{item.alias}</Typography>
                            </Box>
                        </Box>
                    );
                })}
            </Box>
        </>
    );
};

export default HeaderMenuStyle;
